import { Observable, of } from 'rxjs'
import { Container, IInit } from '../../../common/container/Container'
import { HTTP_CLIENT_KEY, IHTTPClient } from '../../../common/api/HTTPClient'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'
import { Query } from '../../../common/api/Query'
import { DownloadsRegister } from '../models/DownloadsRegister'
import { DownloadsRegisterContainerConfig } from '../container'
import { DownloadsRegisterDTO, toModel } from '../models/DownloadsRegisterDTO'
import { prepareURL } from '../../../common/api/http-helpers'
import { catchError, map } from 'rxjs/operators'
import { MonthlyDataQuery } from 'modules/statistics/models/MonthlyData'
import { File as F } from "../../../modules/files/models/File"

export interface IDownloadsRegisterApi extends IInit {


  generateDRXLS(q: Query<MonthlyDataQuery>): Observable<F | undefined>
  
  add(e: DownloadsRegisterDTO): Observable<DownloadsRegister | undefined>


}

export class DownloadsRegisterApi implements IDownloadsRegisterApi {
  private _container!: Container
  private _httpClient!: IHTTPClient
  private _url!: string
  private _statusService!: IStatusService

  init(c: Container) {
    this._container = c
    this._httpClient = this._container.get<IHTTPClient>(HTTP_CLIENT_KEY)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
    this._url = (this._container.config as DownloadsRegisterContainerConfig).moduleFullUrl
  }

  add(e: DownloadsRegisterDTO): Observable<DownloadsRegister | undefined> {
    return this._httpClient.post<DownloadsRegister>({ url: this._url, body: e }).pipe(
      map<DownloadsRegisterDTO, DownloadsRegister>((d) => toModel(d)),
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(undefined)
      })
    )
  }


    generateDRXLS(q: Query<MonthlyDataQuery>): Observable<F | undefined> {
        return this._httpClient.get<F>({ url: prepareURL(this._url + "/download", q) }).pipe(
            map((d) => {
                return d
            }),
            catchError((err) => {
                this._statusService.sendStatus({ variant: 'error', error: err })
                return of(undefined)
            })
        )
    }


}
